import { render, staticRenderFns } from "./preplanning.vue?vue&type=template&id=1fba7a63&"
import script from "./preplanning.vue?vue&type=script&lang=js&"
export * from "./preplanning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports